// Classificação de erros da ponte Capacitor.
//
// Nasceu do Sentry VYV-FRONTEND-4W (31/07, build 44): o card do Apple Saúde
// falhava com `"Health" plugin is not implemented on ios` — plugin fora do
// REGISTRO do binário — e o toast dizia "verifique a permissão em Ajustes",
// mandando o usuário (e o Rafa) caçar um problema de permissão que não
// existia. Erro de plugin AUSENTE não é erro de permissão: a mensagem tem
// que dizer "esta instalação está sem o componente; atualize o app".
//
// A forma do erro (Capacitor 6+): CapacitorException com code "UNIMPLEMENTED"
// quando vem da ponte tipada; via WebView/proxy antigo pode chegar só como
// Error com a message '"X" plugin is not implemented on <platform>'. Os dois
// formatos são cobertos; o teste pina a mensagem REAL do Sentry.

export function isPluginUnimplemented(err: unknown): boolean {
  if (!err) return false;
  const code = (err as { code?: unknown }).code;
  if (typeof code === "string" && code.toUpperCase() === "UNIMPLEMENTED") return true;
  const message = (err as { message?: unknown }).message;
  return typeof message === "string" && /not implemented on (ios|android|web)/i.test(message);
}

/** Quanto de UMA mensagem entra na string final (5 delas cabem em 500 chars). */
export const CAPACITOR_MESSAGE_MAX = 180;

/**
 * A mensagem de um erro que veio (ou pode ter vindo) da ponte nativa.
 *
 * POR QUE ISTO EXISTE — o custo medido: `health_metrics` parou em 04/08 e o
 * banco guardou, para as três métricas do iOS, exatamente
 * `"steps: unknown; heart_rate: unknown; hrv: unknown"`. A causa estava no
 * objeto rejeitado e foi jogada fora por
 * `e instanceof Error ? e.message : "unknown"`: a ponte do Capacitor rejeita
 * com objeto SIMPLES `{ code, message }`, que não é instância de `Error`, e o
 * ternário mandava tudo para o balde "unknown". Onze dias de sync parado sem
 * uma linha de evidência (issue #480).
 *
 * `String(err)` é a outra forma de perder: num objeto ele devolve
 * `"[object Object]"`.
 *
 * A REGRA: a MENSAGEM GANHA; o `code` só aparece quando não há mensagem
 * utilizável. Isso mantém idêntica toda string que já funcionava (nenhuma
 * regressão de UX ao adotar o extrator em call site que já mostrava
 * `.message`) e resgata os dois casos que hoje somem — objeto simples com
 * mensagem, e rejeição só com código.
 */
export function capacitorErrorMessage(err: unknown, fallback = "unknown"): string {
  const cut = (s: string) =>
    s.length > CAPACITOR_MESSAGE_MAX ? s.slice(0, CAPACITOR_MESSAGE_MAX - 1) + "…" : s;

  if (err == null) return fallback;
  if (typeof err === "string") return cut(err.trim()) || fallback;

  const o = err as { message?: unknown; errorMessage?: unknown; code?: unknown };
  // `errorMessage` é a forma que a ponte iOS usa em parte dos caminhos; ler as
  // duas custa uma linha e evita descobrir a diferença em produção.
  for (const campo of [o.message, o.errorMessage]) {
    if (typeof campo === "string" && campo.trim()) return cut(campo.trim());
  }
  if (typeof o.code === "string" && o.code.trim()) return cut(o.code.trim());
  return fallback;
}
